module.exports = __webpack_public_path__ + "img/womanWithLaptop.e3a0edbb.svg";